const BannerStatusEnum = {
    ACTIVE: 1,
    IN_ACTIVE: 2
}
export default BannerStatusEnum



// WEBPACK FOOTER //
// ./src/enum/bannerStatusEnum.js